<ion-item lines="none">
  <ion-text color="danger">
    <b>{{to.label}}</b>
  </ion-text>
</ion-item>